module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, _vm._l((_vm.dataList), function(d) {
    return _c('span', [_c('span', {
      staticStyle: {
        "font-size": "20px"
      }
    }, [_vm._v(_vm._s(d.RName))]), _c('br'), _vm._v(" "), _c('svg', {
      attrs: {
        "id": 'code' + d.DataID
      }
    }), _c('hr', {
      staticStyle: {
        "margin": "40px 0px"
      }
    })])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-030c2a24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/BarCode.vue
// module id = 827
// module chunks = 1